var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, customElement, html, LitElement, property } from 'lit-element';
import page from 'page';
import './components/cst-snackbar/cst-snackbar';
import './components/cst-header/cst-header';
import './components/cst-loading/cst-loading';
import './components/cst-loading/cst-loading-container';
import { NavigateEvent } from './utilities/events';
import CSTStyles from './styles/cst-styles/cst-styles';
import lazyLoad from './utilities/lazy-load';
import { getApiUrl } from './utilities/api';
let CSTAppElement = class CSTAppElement extends LitElement {
    constructor() {
        super();
        this._installRoutes();
        this.addEventListener(NavigateEvent.eventName, (event) => page.show(event.detail));
        // First load make a call to get a jsonbox
        // store this in local storage
        // https://jsonbox.io/box_1f9996813bc8ce189395
        if (!getApiUrl())
            localStorage.setItem('apiUrl', 'https://jsonbox.io/box_1f9996813bc8ce189395');
    }
    firstUpdated() {
        page.redirect('/login');
    }
    _installRoutes() {
        page.redirect('/', '/vehicles');
        page('/vehicles', this._vehiclesRoute.bind(this));
        page('/vehicle/:id', this._vehicleRoute.bind(this));
        page('/add-vehicle', this._addVehicleRoute.bind(this));
        page('/login', this._loginRoute.bind(this));
        page('/create-account', this._createAccountRoute.bind(this));
        page('/settings', this._settingsRoute.bind(this));
        page('*', this._notFoundRoute.bind(this));
        page();
    }
    _loginRoute() {
        this.currentView = 'login';
    }
    _createAccountRoute() {
        this.currentView = 'create-account';
    }
    _vehiclesRoute() {
        this.currentView = 'vehicles';
    }
    _addVehicleRoute() {
        this.currentView = 'add-vehicle';
    }
    _vehicleRoute(context) {
        this.currentView = 'vehicle';
        this.vehicleId = context.params['id'];
    }
    _settingsRoute() {
        this.currentView = 'settings';
    }
    _notFoundRoute() {
        this.currentView = 'not-found';
    }
    _renderCurrentView(currentView) {
        switch (currentView) {
            case 'vehicles':
                return lazyLoad(import('./components/cst-list/cst-list.js'), html `
            <cst-list></cst-list>
          `);
            case 'vehicle':
                return lazyLoad(import('./components/cst-vehicle/cst-vehicle.js'), html `
            <cst-vehicle .vehicleId=${this.vehicleId}></cst-vehicle>
          `);
            case 'not-found':
                return lazyLoad(import('./components/cst-404/cst-404.js'), html `
            <cst-404></cst-404>
          `);
            case 'add-vehicle':
                return lazyLoad(import('./components/cst-add-vehicle/cst-add-vehicle.js'), html `
            <cst-add-vehicle></cst-add-vehicle>
          `);
            case 'login':
                return lazyLoad(import('./components/cst-login/cst-login.js'), html `
            <cst-login></cst-login>
          `);
            case 'create-account':
                return lazyLoad(import('./components/cst-create-account/cst-create-account.js'), html `
            <cst-create-account></cst-create-account>
          `);
            case 'settings':
                return lazyLoad(import('./components/cst-settings/cst-settings.js'), html `
            <cst-settings></cst-settings>
          `);
            default:
                return html ``;
        }
    }
    render() {
        return html `
      <loading-veil ?hidden=${!this.isLoading}>
        <cst-loading-container ?hidden=${!this.isLoading}>
          <cst-loading size="24"></cst-loading>
        </cst-loading-container>
      </loading-veil>
      <cst-header ?invisible=${this.isLoading}></cst-header>
      <main-content ?invisible=${this.isLoading}>
        ${this._renderCurrentView(this.currentView)}
      </main-content>
      <cst-snackbar></cst-snackbar>
    `;
    }
};
CSTAppElement.styles = css `
    ${CSTStyles} :host {
      --app-primary-color: #86addb;
      --app-secondary-color: #b8b8b8;
      --app-text-color: #5c5c5c;
      --app-hover-color: #757575;
      --lazy-image-width: 150px;
      --lazy-image-height: 100px;
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      min-height: 100vh;
    }

    loading-veil {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: #f9f9f9;
    }

    main-content {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      margin: 0 auto;
      max-width: 700px;
      width: 100%;
      transition: 0.3s ease;
      opacity: 1;
    }

    cst-header {
      opacity: 1;
    }

    [invisible] {
      opacity: 0;
      transition: none;
    }

    [hidden] {
      display: none;
    }
  `;
__decorate([
    property({ type: Boolean })
], CSTAppElement.prototype, "isLoading", void 0);
__decorate([
    property({ type: String })
], CSTAppElement.prototype, "page", void 0);
__decorate([
    property({ type: String })
], CSTAppElement.prototype, "currentView", void 0);
__decorate([
    property({ type: String })
], CSTAppElement.prototype, "vehicleId", void 0);
CSTAppElement = __decorate([
    customElement('cst-app')
], CSTAppElement);
export { CSTAppElement };
//# sourceMappingURL=cst-app.js.map